import { actions, reducer as collection, selectors } from './store';
export { default } from './Collection';
export const store = { actions, reducers: { collection }, selectors };
